export const GET_AVAILABLE_SCHEDULES = "GET_AVAILABLE_SCHEDULES";
export const GET_USER_DATA = "GET_USER_DATA";
export const SELECT_SCHEDULE = "SELECT_SCHEDULE";
export const SELECT_DATE = "SELECT_DATE";
export const SELECT_DATE_SUCCESS = "SELECT_DATE_SUCCESS";	
export const SELECT_DATE_ERROR = "SELECT_DATE_ERROR";
export const CREATE_CONTACT = "CREATE_CONTACT";
export const CREATE_BOOKING = "CREATE_BOOKING";
export const CONFIRM_BOOKING = "CONFIRM_BOOKING";
export const GET_BRANCH_NAME = "GET_BRANCH_NAME";
export const SET_APPOINTMENT = "SET_APPOINTMENT";
export const SET_SELECTED_DATE = "SET_SELECTED_DATE";
export const SET_LOADER = "SET_LOADER";
export const SET_ERROR_APPOINTMENT = "SET_ERROR_APPOINTMENT";